import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-width": "1.5",
      d: "m9.618 22-.25-3.509a3.259 3.259 0 1 1 6.501 0L15.62 22"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.97 13.214c-.352-2.298-.529-3.446-.095-4.465S4.273 7.034 6.2 5.641L7.64 4.6C10.037 2.867 11.236 2 12.62 2c1.382 0 2.58.867 4.978 2.6l1.44 1.041c1.927 1.393 2.89 2.09 3.325 3.108.434 1.019.258 2.167-.095 4.464l-.301 1.96c-.5 3.256-.751 4.884-1.919 5.856s-2.875.971-6.29.971H11.48c-3.415 0-5.122 0-6.29-.971-1.168-.972-1.418-2.6-1.918-5.857z"
    }, null, -1)
  ])))
}
export default { render: render }